import { createFileRoute } from "@tanstack/react-router";

import { ApplyPage } from "@/features/apply/apply-page";

/** 企業（案件掲載側）の利用申込。アカウント未発行の人が使うため認証ガードは付けない。 */
export const Route = createFileRoute("/apply/enterprise")({
  component: () => <ApplyPage kind="ENTERPRISE_APPLICATION" />,
});
